import LicenseProto from "./license-proto";
import {License} from "../const/license";
import {ViewType} from "../const/views/view-type";

export default class LicenseProfessional2023 extends LicenseProto {

    constructor(licenseUsers:number) {
        super(License.PRO_2023)

        this.maxUsers                   = 250
        this.maxAttachmentMb            = 500

        this.isPro                      = true
        this.isBusiness                 = false

        this.billingAndFinance          = true
        this.maxStorage                 = 'Unlimited'
        this.name                       = 'Professional [GD-P23]'

        this.isPaid                     = true

        this.licenseUsers               = licenseUsers ? licenseUsers:  false

        this.prohibitedHomeViews        = [ViewType.MY_WORK_WORKLOAD]
        this.prohibitedProjectViews     = [ViewType.PROJECT_WORKLOAD]
        this.prohibitedPortfolioViews   = [ViewType.PROJECT_WORKLOAD]
        this.prohibitedCustomViews      = [ViewType.PROJECT_WORKLOAD]

    }
}